import {
	forwardRef,
	type InputHTMLAttributes,
	type SelectHTMLAttributes,
	type TextareaHTMLAttributes,
} from 'react';

import { cn } from '@/lib/utils';

const baseField =
	'w-full rounded-lg border border-loomlite-border bg-loomlite-ink px-3 py-2.5 text-sm text-loomlite-text placeholder:text-loomlite-dim outline-none transition focus:border-loomlite-purple focus:ring-[3px] focus:ring-loomlite-purple/20 disabled:opacity-50';

export const Input = forwardRef<HTMLInputElement, InputHTMLAttributes<HTMLInputElement>>(
	({ className, type, ...props }, ref) => (
		<input ref={ref} type={type} className={cn(baseField, 'h-10', className)} {...props} />
	),
);
Input.displayName = 'Input';

export const Textarea = forwardRef<HTMLTextAreaElement, TextareaHTMLAttributes<HTMLTextAreaElement>>(
	({ className, ...props }, ref) => (
		<textarea ref={ref} className={cn(baseField, 'resize-y leading-relaxed', className)} {...props} />
	),
);
Textarea.displayName = 'Textarea';

export const Select = forwardRef<HTMLSelectElement, SelectHTMLAttributes<HTMLSelectElement>>(
	({ className, children, ...props }, ref) => (
		<select
			ref={ref}
			className={cn(baseField, 'h-10 appearance-none pr-9 cursor-pointer', className)}
			{...props}
		>
			{children}
		</select>
	),
);
Select.displayName = 'Select';
